import { Spinner } from '@/shared/ui'

export const ReviewDialogFallback = () => {
  return (
    <div className="flex w-100 grow items-center justify-center p-6">
      <p className="typo-body1 text-center font-medium text-gray-400">
        리뷰를 가져오는 중 오류가 발생했습니다.
        <br />
        잠시 후 다시 시도해 주세요.
      </p>
    </div>
  )
}

export const ReviewDialogLoadingFallback = () => {
  return (
    <div className="relative flex w-100 grow items-center justify-center">
      <Spinner />
    </div>
  )
}
